"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeTrackingFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const objects_1 = require("../../type-checking/objects");
const typing_1 = require("../../type-checking/typing");
const primitives_1 = require("../../type-checking/primitives");
const time_tracking_1 = require("../../type-checking/time-tracking");
const number_1 = require("../../type-checking/number");
class TimeTrackingFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                active: (0, typing_1.Optional)(primitives_1.isBooleanValue),
                total_duration: number_1.isNullableNumberValue,
                time_track_logs: (0, typing_1.Optional)(time_tracking_1.isTimeTrackLogsValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getTimeTrackingFieldEmptyValue)();
    }
}
exports.TimeTrackingFieldValueGetter = TimeTrackingFieldValueGetter;
